import React from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import SearchFIles from "./SearchFIles";
import CustomeButton from "~/components/Button";
import FolderSkeleton from "./FolderSkeleton";
import Folders from "./Folders";

const ProcessFileDocuments = () => {
  const { id, service_id, process_id, type } = useParams();
  const {
    states,
    fileName,
    setFileName,
    processName,
    rows,
    first,
    onPageChange,
    handleOpenProcess,
    handleClickPayslip,
  } = useFileDocuments({ id, service_id, type, process_id });
  return (
    <>
      {states?.selectedService?.name === "Payroll" && (
        <div className="service-folder-container">
          <p className="document-sub-heading"> Folders</p>
          {states.loading ? (
            <FolderSkeleton />
          ) : (
            <Folders
              folders={states?.folders}
              onFolderClick={handleClickPayslip}
            />
          )}
        </div>
      )}
      {!states.loading && (
        <>
          {states?.selectedProcess?.isProcess && (
            <CustomeButton
              onClick={handleOpenProcess}
              label="Open Process"
              className="cancel-btn ml-auto mb-3"
              icon="pi pi-external-link"
              iconPos="right"
            />
          )}
          <SearchFIles
            fileName={fileName}
            setFileName={setFileName}
            additionaltag={{ entity: [states?.entity_detail?.name] }}
            states={states}
            processName={processName}
            first={first}
            rows={rows}
            onPageChange={onPageChange}
          />
        </>
      )}
    </>
  );
};

export default ProcessFileDocuments;
